import api from './interceptor';

const BASE_URL_V2 = 'api/v2/rpm-order';

export default {
  // API Version 2
  getRpmOrder: params => api.get(`${BASE_URL_V2}`, { params }),
  editRpmOrder: (orderId, params) => api.put(`${BASE_URL_V2}/${orderId}`, params),
  createRpmOrder: (patientId, params) => api.post(`${BASE_URL_V2}/${patientId}`, params),
  getPatientCount: (accountId, params) => api.get(`${BASE_URL_V2}/patients-count/${accountId}`, { params }),
  editRpmOrderDetails: (accountId, params) => api.put(`${BASE_URL_V2}/order-details/${accountId}`, params),
};
